import { render, staticRenderFns } from "./TimeLimitation.vue?vue&type=template&id=216ae50c&"
import script from "./TimeLimitation.vue?vue&type=script&lang=js&"
export * from "./TimeLimitation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports